import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

const fmtD = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "");
const n = (v) => Number(v || 0).toLocaleString("es-ES");
const period = (s) => (s.period_start && s.period_end ? `${fmtD(s.period_start)} – ${fmtD(s.period_end)}` : s.label || "Estudio");

// cns: lista de CN a sumar (producto); sin cns → totales de cada estudio
export function StudiesTooltip({ demand, cns, note, testid, children }) {
  const studies = demand?.studies || [];
  if (!studies.length) return children;
  const byCn = demand.units_by_cn || {};
  const rows = studies.map((s, i) => ({
    p: period(s),
    u: cns ? cns.reduce((acc, cn) => acc + ((byCn[cn] || [])[i] || 0), 0) : s.units || 0,
  }));
  const total = rows.reduce((a, r) => a + r.u, 0);
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help underline decoration-dotted underline-offset-2" data-testid={testid}>{children}</span>
        </TooltipTrigger>
        <TooltipContent className="bg-slate-900 text-white p-3 max-w-xs normal-case tracking-normal" data-testid={`${testid}-content`}>
          <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400 mb-1.5">
            {cns ? "Unidades de este producto por estudio" : "Unidades por estudio"}
          </div>
          <table className="text-xs w-full">
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} data-testid={`${testid}-row-${i}`}>
                  <td className="pr-4 py-0.5 text-slate-200">{r.p}</td>
                  <td className="py-0.5 text-right font-mono-num font-bold">{n(r.u)} uds</td>
                </tr>
              ))}
              <tr className="border-t border-slate-700">
                <td className="pr-4 pt-1 font-bold">Total sumado</td>
                <td className="pt-1 text-right font-mono-num font-bold text-emerald-300" data-testid={`${testid}-total`}>{n(total)} uds</td>
              </tr>
            </tbody>
          </table>
          {note && <div className="text-[10px] text-slate-400 mt-1.5">{note}</div>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function lineSourceCns(l) {
  const src = [...(l.redirected_from || []), ...(l.marca_conversion_from || []), ...(l.own_breakdown || [])]
    .map((x) => x.cn).filter(Boolean);
  return src.length ? [...new Set(src)] : [l.cn];
}
